import { SettingsOptionsDai } from './types';

export const settingsOptionsDaiDefaultValue: SettingsOptionsDai = {
  searchCondition: {
    areas: [],
    halls: [],
    shuList: [],
    shuGroupList: [],
  },
  fields: {
    dai: [],
    transition: [],
    dtmaRanking: [],
  },
  genres: {
    dai: [],
    transition: [],
    dtmaRanking: [],
  },
};
